import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
// import TableComponent from "./AssetDetailsTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import axios from "axios";
import { clientAccess } from "../../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class Import extends React.Component {
  state = {
    LandlordGroups: [],
    clientList: [],
    redirect: false,
    url: `${apiUrl.apiUrl.url}/import/import-data`,
    id: undefined,
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
    },
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-asset-types`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
    console.log(this.groupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  redirectAfterEdit = () => {
    this.setState({ redirect: true })
  }

  onFileChange = (event) => {
    // Update the state
    console.log(event, "event target file");
    this.setState({ selectedFile: event.target.files[0] });
  };
  // On file upload (click the upload button)
  onFileUpload = () => {
    // Create an object of formData
    const formData = new FormData();

    console.log(formData, "formData");

    if (typeof this.state.selectedFile == "undefined") {
      // alert("Please upload file to process");
      this.setState({
        popupalertMessage: true,
        popupMessageContent: 'Please upload file to process',
      });
      return true;
    }

    var ths = this;

    // Update the formData object
    formData.append(
      "myFile",
      this.state.selectedFile,
      this.state.selectedFile.name
    );
    formData.append("type", this.state.importType);
    // Request made to the backend api
    // Send formData object
    axios
      .post(`${apiUrl.apiUrl.url}/import/import-data`, formData)
      .then(function (response) {
        console.log(response, "response");
        if (response.data.success) {
          ths.setState({ redirect: true });
          ths.state.brandSelected = [];
          ths.state.leaseSelected = [];

          // alert("Form processed successfully.");
          ths.setState({
            popupalertMessage: true,
            popupMessageContent: 'Form processed successfully.',
          });
          for (const [key, value] of Object.entries(ths.state.initialValues)) {
            ths.state.initialValues[key] = "";
          }
          ths.setState({
            formResponseData: {
              forecasteDetails: {
                forecast: [],
                actual: {},
              },
            },
            initialForecast: [],
            exportBtn: false,
          });
          ths.setState({});
        }
      });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/import" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  clear(resetForm) {
    resetForm({
      values: {
        ownershipType: "",
        clientName: "",
        clientGroup: "",
      },
    });
    this.setState({
      initialValues: {
        groupName: "",
        clientName: "",
      },
    });
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li>
                <Link to="/masters/unit-directory">Unit Directory</Link>
              </li>
              <li>
                <Link to="#">Asset Detail</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log("form submitted");
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            resetForm,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="container">
                  <div className="row">
                    {clientAccess() && (
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Client Group <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientGroup"
                                //onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(
                                    e,
                                    "change_client_group"
                                  );
                                }}
                                value={{
                                  label: this.state.initialValues.groupName,
                                  value: this.state.initialValues.groupId,
                                }}
                                options={this.state.LandlordGroups.map(
                                  (item) => ({
                                    label: item.group_name,
                                    value: item.id,
                                  })
                                )}
                              />

                              <ErrorMessage
                                name="clientGroup"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {clientAccess() && (
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Client Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientName"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(
                                    e,
                                    "change_client_name"
                                  );
                                }}
                                value={{
                                  label: this.state.initialValues.clientName,
                                  value: this.state.initialValues.clientId,
                                }}
                                options={this.state.clientList.map((item) => ({
                                  label: item.client_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="clientName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Data <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Field
                              as="select"
                              name="importType"
                              onChange={(e) => {
                                handleChange(e);
                                this.setState({ "importType": e.target.value });
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="asset" label="Asset & Unit Details" />
                              <option value="landlord" label="Landlord" />
                              <option value="occuipier" label="Occupier" />
                              <option value="lease" label="Lease Master" />
                            </Field>
                            {/* ownershipType */}
                            <ErrorMessage
                              name="importType"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Upload File <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Field
                              name="myfile"
                              type="file"
                              onChange={this.onFileChange}
                            />
                            <ErrorMessage
                              name="ownershipType"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                      <div className="btnContainer">
                        <div>
                          <button onClick={this.onFileUpload}>Upload</button>

                          <button
                            type="reset"
                            onClick={() => this.clear(resetForm)}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </>
    );
  }
}

export default withRouter(Import);
